import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import SuccessImage from 'shared/images/home.webp'
import { Button } from 'shared/ui/button'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

type Props = {
  onClick: () => void
}

export const KyrgyzstanSuccess = ({ onClick }: Props) => {
  const { t } = useTranslation()

  return (
    <div className={clsx('safe-area-top-padding', s.container)}>
      <div className={s.content}>
        <ImageLazy
          src={SuccessImage}
          alt={'image'}
          className={s.successImage}
        />

        <div className={s.text}>
          <p className={clsx(s.title, 'bold-24')}>
            {t('kyrgyzstan_block.booking.success.title')}
          </p>
          <p className={clsx(s.description, 'medium-16')}>
            {t('kyrgyzstan_block.booking.success.description')}
          </p>
        </div>

        <Button
          variant="grey"
          className={s.button}
          onClick={onClick}
        >
          <span className={clsx(s.buttonText, 'bold-16')}>{t('go_home')}</span>
        </Button>
      </div>
    </div>
  )
}
